import { Paper, Typography } from '@mui/material'
import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'

import but from '../../../../images/game-fact/but.png'

import {notation_custoquestion_all} from '../../../../bdd/bddSTUB.js'
import { getVisualTimer } from '../../sports/rules.js'

const RecapNotation = ({notation, match}) => {

    const {customQuestion, globalTarget, preciseTarget, exactTarget, timer, period} = notation

    const getRecap = useCallback(() => {
        if(customQuestion){
            let selectedQuestion = notation_custoquestion_all.find(c => c._id === customQuestion)
            
            if(!selectedQuestion)
                return <Typography>Notation : {customQuestion}</Typography>
            
            return <Typography>Notation : {selectedQuestion.name}</Typography>
        }


        const {homeHolders, homeSubstitutes, awayHolders, awaySubstitutes, homeTeam, awayTeam} = match
        let allPlayers = [...homeHolders, ...homeSubstitutes, ...awayHolders, ...awaySubstitutes]

        if(globalTarget==='match'){
            return <Typography>Notation du match</Typography>
        }else if(preciseTarget==="team"){
            let notedTeam = [homeTeam, awayTeam].find(t => t._id === globalTarget)
            return <Typography>Notation de l'équipe : {notedTeam.name}</Typography>
        }else if (exactTarget){
            let notedPlayers = allPlayers.filter(p => exactTarget.includes(p._id))
            return notedPlayers.map(p => <Typography>Notation du joueur : {p.lastname}</Typography>)
        }

    }, [notation, match])

    return (
        <div>
         <Paper
          sx={{
            padding: 2,
            marginBottom: 2,
            backgroundColor: '#f9f9f9',
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
            borderRadius: '15px',
          }}
        >
            {getRecap()}
        </Paper>
        
        {!customQuestion && <Typography>Minute : {getVisualTimer(period, timer/60, match.discipline)}</Typography>}
        </div>
    )
}

export default RecapNotation